import { useMemo } from 'react';

import { Grid, Typography } from '@mui/material';

import { MetaTags } from '@redwoodjs/web';

import TableList from 'src/components/TableList/TableList';
import { COMMISSIONS_TABLE_HEADERS, DEFAULT_BORDER } from 'src/constants';
import {
    useCommissionStatementsFilters,
    useFilteredCommissionStatements,
} from 'src/features/finance/commissionStatement/hooks';
import { commissionFilters, updateTableFilters } from 'src/utils/tableUtils';

const ViewTransactionCommissionsPage = () => {
    const commissionType = 'TRANSACTION';

    const { idFilters, partnerNameFilters } = useCommissionStatementsFilters(commissionType);

    const { filteredData: tableData, setTableFilters } = useFilteredCommissionStatements({
        commissionType,
    });

    const filterOptions = useMemo(
        () => commissionFilters(idFilters, partnerNameFilters),
        [idFilters, partnerNameFilters]
    );

    const handleViewTransactionCommission = () => {
        // TODO: implement view transaction commission
    };

    return (
        <>
            <MetaTags title="TransactionCommissions" description="Transaction Commissions page" />
            <Grid container sx={{ gap: '24px' }}>
                <Grid
                    item
                    xs={12}
                    sx={{
                        ...DEFAULT_BORDER,
                        height: '116px',
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '8px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#1D1D1B' }}>
                        Transaction Commission
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {/* TODO: Display loader if data is still fetching */}

                    <TableList
                        data={tableData}
                        headers={COMMISSIONS_TABLE_HEADERS}
                        handleViewRecord={handleViewTransactionCommission}
                        //TODO: add the delete functionality
                        deleteRecordCallBack={() => {}}
                        enableFilter
                        enableExport
                        isCommissionsTable
                        enableFilterByDateRange
                        filterOptions={filterOptions}
                        updateTableFilters={(filter: string, newFilterValue: string) =>
                            setTableFilters((prevFilters) =>
                                updateTableFilters(prevFilters, newFilterValue, filter)
                            )
                        }
                    />
                </Grid>
            </Grid>
        </>
    );
};
export default ViewTransactionCommissionsPage;
